module.exports = __webpack_public_path__ + "static/media/instagram.3f4e62a5.svg";